import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import { Input } from '@src/elements/input/input'
import { Subtitle1 } from '@src/elements/typography/typography'

@Component({
  computed: {
    trainingPlanName: {
      get () {
        return this.$store.state.new_training_plan.selectedTrainingPlan.name
      },
      set (name: string) {
        this.$store.state.new_training_plan.selectedTrainingPlan.name = name
      }
    }
  }
})
export class TrainingPlanName extends Vue {

  @Prop({ required: false, default: false })
  disabled: boolean

  private trainingPlanName: string

  render (h: CreateElement) {
    if (this.disabled) {
      return <Subtitle1 class='name'>{this.trainingPlanName}</Subtitle1>
    }

    return <Input label={this.$t('PAGE.CLUB.ARRANGEMENT_SETTINGS.NAME')}
                  class={ this.trainingPlanName ? 'name' : 'name-error'}
                  valueChanged={(value: string) => this.trainingPlanName = value}
                  value={this.trainingPlanName}
                  maxLength={50}
                  disabled={this.disabled} />
  }
}
